import React, { forwardRef, useImperativeHandle, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { Input } from 'reactstrap'
import { Search as SearchIcon } from 'react-feather'
import styled from 'styled-components'

function SearchInputImperative(
  { placeholder, onChange = () => {}, ...props },
  ref
) {
  const [value, setValue] = useState('')

  const handleChange = e => {
    setValue(e?.target?.value)
    onChange(e?.target?.value)
  }

  useImperativeHandle(ref, () => {
    return {
      setValue,
    }
  })
  return (
    <InputContainer>
      <FormattedMessage id={placeholder}>
        {txt => (
          <Input
            {...props}
            placeholder={txt}
            value={value}
            onChange={handleChange}
            ref={ref}
          />
        )}
      </FormattedMessage>
      <SearchIcon />
    </InputContainer>
  )
}

const InputContainer = styled.div`
  position: relative;
  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.133);
  border-radius: 8px;

  input {
    min-height: 60px;
    font-size: 16px;
    font-family: 'Montserrat';
    padding: 0 20px;
    border: none;
    border-radius: 8px;

    &::placeholder {
      font-family: 'Montserrat';
      font-style: normal;
      font-weight: 300;
      font-size: 16px;
      line-height: 26px;
      color: #999999;
    }
  }

  svg {
    position: absolute;
    right: 16px;
    top: 16px;
    pointer-events: none;
  }
`

export default forwardRef(SearchInputImperative)
